export const MAIN_WINDOW_ID = 'mainWindow';
export const MAIN_APP_ID = 'mainApp';
